import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default class Animations {
    constructor() {
        this.animationBlocks = document.querySelectorAll('[data-animate]');
        this.animationBlocks.forEach(animationBlock => {
            // Animation Types
            let fadeInElements = animationBlock.querySelectorAll('[data-animate-in]');
            if (!fadeInElements.length)
                return;
            let offset = animationBlock.getAttribute('data-animate-offset');
            let duration = animationBlock.getAttribute('data-animate-duration');
            let stagger = animationBlock.getAttribute('data-animate-stagger');
            let elementX = animationBlock.getAttribute('data-animate-x');
            let elementY = animationBlock.getAttribute('data-animate-y');
            let staggerVal = stagger ? parseFloat(stagger) : 0;
            let durationVal = duration ? Math.abs(parseFloat(duration)) : 1;
            let posYVal = elementY ? parseInt(elementY) : 0;
            let posXVal = elementX ? parseInt(elementX) : 0;
            let offsetValue = '';
            let offsetNr = 0;
            if (offset) {
                offsetNr = parseInt(offset);
                offsetValue = offsetNr >= 0 ? `+=${offsetNr}` : `-=${Math.abs(offsetNr)}`;
            }
            gsap.set(fadeInElements, { opacity: 0, x: posXVal, y: posYVal });
            ScrollTrigger.create({
                trigger: animationBlock,
                start: `top${offsetValue} center`,
                once: true,
                onEnter: (self) => {
                    let animate = {
                        to: { opacity: 1, x: 0, y: 0, duration: durationVal, stagger: staggerVal }
                    };
                    gsap.to(fadeInElements, animate.to);
                }
            });
        });
    }
}
